import styled from 'styled-components';

export const HowItWorksList = styled.ol`
  margin: 0;
  padding-left: 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.82rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-bottom: 0.85rem;
`;

export const ToolbarRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

export const SearchInput = styled.input`
  flex: 1;
  min-width: 180px;
  padding: 0.45rem 0.65rem;
  font-size: 0.85rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => `${theme.colors.primary}44`};
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const WorkspaceField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
  min-width: 200px;
  flex: 1;
`;

export const WorkspaceSelect = styled.select`
  padding: 0.45rem 0.65rem;
  font-size: 0.85rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const WorkspaceHint = styled.span`
  font-weight: 400;
  font-size: 0.72rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CategoryPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
`;

export const CategoryPill = styled.button<{ $active: boolean }>`
  padding: 0.28rem 0.6rem;
  font-size: 0.72rem;
  font-weight: 600;
  border-radius: 999px;
  border: 1px solid
    ${({ $active, theme }) =>
      $active ? theme.colors.primary : theme.colors.border.light};
  background: ${({ $active, theme }) =>
    $active ? `${theme.colors.primary}12` : theme.colors.background};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.text.secondary};
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const IntroDivider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  margin: 1rem 0;
`;

export const SubsectionLabel = styled.h4`
  margin: 0 0 0.5rem;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CreatePromptRow = styled.div`
  margin-bottom: 0.85rem;
`;

export const AllPromptsAccordion = styled.div`
  margin-top: 0.85rem;

  /* Compact accordion chrome to match dashboard cards */
  & > div {
    border: 1px solid ${({ theme }) => theme.colors.border.light};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    overflow: hidden;
  }
`;

export const AccordionBody = styled.div`
  padding-top: 0.65rem;
`;

export const FooterLink = styled.div`
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`;
